/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_components.table, {
    children: [_jsx(_components.thead, {
      children: _jsxs(_components.tr, {
        children: [_jsx(_components.th, {
          children: "Event"
        }), _jsx(_components.th, {
          children: "Description"
        })]
      })
    }), _jsxs(_components.tbody, {
      children: [_jsxs(_components.tr, {
        children: [_jsx(_components.td, {
          children: _jsx(_components.code, {
            children: "onChange"
          })
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " Will be called on value changes made by the user, with the new value as argument."]
        })]
      }), _jsxs(_components.tr, {
        children: [_jsx(_components.td, {
          children: _jsx(_components.code, {
            children: "onFocus"
          })
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " Will be called when the component gets into focus. Like clicking inside a text input or opening a dropdown. Called with active value as argument."]
        })]
      }), _jsxs(_components.tr, {
        children: [_jsx(_components.td, {
          children: _jsx(_components.code, {
            children: "onBlur"
          })
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " Will be called when the component stop being in focus. Like when going to next field, or closing a dropdown. Called with active value as argument."]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
